import { theme } from 'src/styles/theme';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Recorder from 'src/components/Recorder';
import HeaderComp from './HeaderComp';
import useRecorder from 'src/hooks/useRecorder';
import { Icon } from 'src/components/Icon';
import { FaCircle, FaSquare } from 'react-icons/fa6';
import { IoPerson, IoPersonCircle, IoPersonCircleSharp, IoPlaySkipBackSharp, IoPlaySkipForward } from 'react-icons/io5';
import { CgHeadset } from "react-icons/cg";
import VideoPlayer from 'src/components/VideoPlayer';
import { FiCheck, FiMoreHorizontal } from 'react-icons/fi';
import { css } from 'styled-components';
import CircularProgress from 'src/components/CircularProgress';
import { BsFillPauseFill, BsFillPlayFill, BsPersonCircle, BsPersonFill } from 'react-icons/bs';
import SideMenu from './Sidemenu';
import { useNavigate } from 'react-router-dom';
import { GrRotateRight } from 'react-icons/gr';
import { IndexedVideo } from 'src/store/qcasts/data';
import useWhisper from 'src/hooks/useWhisper';
import { useMediaQuery } from 'react-responsive';
import { Tooltip as ReactTooltip } from "react-tooltip";

// Types
interface QcastStudioProps {
  qcastVideos: any;
  questionNumber?: number;
  totalQuestions?: number;
  setSnapshot: (snapshot: any) => void;
  userAvatar?: string;
  respondentAvatar?: string;
  onCancel?: () => void;
  onRecord?: () => void;
  onPlayback?: () => void;
  onnavigateVideo?: (index: number) => void;
}

// Styled Components
const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.88), rgba(0, 0, 0, 0.88)), linear-gradient(0deg, rgba(19, 42, 131, 0.16), rgba(19, 42, 131, 0.16));
  border-top-left-radius: 20px;
border-top-right-radius: 20px;
  @media (max-width: ${theme.breakpoints.mobile}px) {
    border-top-right-radius: 20px;
  }
`;

const PageContent = styled.div`
  width: 100%;
  height: calc(100% - 128px);
  flex:1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
  padding: 40px;
  padding-top: 0px;

  

  @media (max-width: ${theme.breakpoints.tablet}px) {
    padding: 20px 20px ;
    gap: 15px;
  }
  @media (max-width: ${theme.breakpoints.mobile}px) {
    // padding: 20px 10px ;
    gap: 15px;
    width: 100%;
    // height: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;


const Content = styled.div`
// width: 520px;
  flex: 1;
  //display: flex;
  //flex-direction: column;
  //align-items: center;
  //justify-content: space-between;
  padding: 0px 0;
  display: grid;
    grid-template-rows: 30px 30% 70%;
  // padding-bottom: 48px;
  gap: 10px;
  place-items: center;
  padding-bottom:30px;
  @media (max-width: ${theme.breakpoints.mobileBig}px) {
    grid-template-rows:unset;
    }
  
`;

const QuestionIndicator = styled.div`
    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.regular};;
    font-size: ${theme.fontSizes.md};;
    line-height: 135%;
    letter-spacing: 0%;


    opacity: 1;
    // margin-bottom: 20px;

    z-index: 999999999999999;
    position: relative;
`;

const UserAvatar = styled.div<{ size?: string, image?: string, active?: boolean }>`
  //width: ${props => props.size || "160px"};
  //height: ${props => props.size || "160px"};
  height:100%;
  // width:100%;
  border-radius: 50%;
  display:flex;
  justify-content:center;
  background-image: ${props => `url(${props.image})`};
  background-size: cover;
  background-position: center;
  // margin-bottom: 40px;
 // box-shadow: 0px 30px 100px -20px #00000033;
  ${props => props.active && css`
    z-index: 999999999999999;
    `};
  @media (max-width: ${theme.breakpoints.mobile}px) {
    width: 150px;
    height: 150px;
  } 

`;

const UserProfileAvatar = styled.div<{ size?: number }>`
  width: ${props => `${props.size / 4}px` || "120px"};
  height: ${props => `${props.size / 4}px` || "120px"};
  border-radius: 50%;
  margin-bottom: 40px;
  box-shadow: 0px 30px 100px -20px #00000033;
  background: #39393A;
  position:absolute;
  right: 0px;
  bottom: -10px;
  z-index: 99999999999999999999;
  clip-path: circle(50% at center); 
  aspect-ratio: 1 / 1;

  &>svg{
    width: 100%;
    height: 100%;
    //margin-top: 20px;
  }

  @media (max-width: ${theme.breakpoints.mobile}px) {
    width: 100px;
    height: 100px;
    right: -10px;
    bottom: -40px;
  } 
`;

const RespondentContainer = styled.div<{ size?: string }>`
  //width: ${props => props.size || "440px"};
  height: 100%;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  // margin-bottom: 50px;
  z-index: 999999999999;
  aspect-ratio: 1 / 1;

  @media (max-width: ${theme.breakpoints.mobile}px) {
    width: 280px;
    height: 280px;
  }
`;



const Controls = styled.div`
  // height: 128px;
/*   width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  z-index: 999999999999999;
  position: relative;
  padding: 0px 40px;
  position:relative; */
   display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  position: relative;
  gap:24px;

`;

const SubControls = styled.div`
 display:flex;
 gap: 24px;
`;

const ControlButton = styled.button<{ active?: boolean }>`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background-color: #4a4a52;
  color: #1a1a21;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => props.active ? 'pointer' : 'not-allowed'};
  transition: all 0.2s;
     margin-bottom: 10px;
  
  &:hover {
    transform: scale(1.05);
  }
`;

const BlankButton = styled(ControlButton)`
  border: none;
  background-color: transparent;
  cursor: defaukt;

  @media (max-width: ${theme.breakpoints.mobile}px) {
    display: none;
  }
`;

const RecordButton = styled(ControlButton)`
  width: 80px;
  height: 80px;
  cursor: pointer;
  background: #0000001A;
    gap: 8px;
    border-radius: 44px;
    padding: ${props => props.active ? '18px' : '5px'};
    border-width: 3px;
    border: 3px solid #FFFFFF80
`;

const SideTools = styled.div`
    // width: 616px;
    // height: 176px;
    // position: fixed;
    // right: 20px;
    // top: 50%;
    // transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: end;
    justify-content: center;
    z-index: 999999999999999;
`;

const ToolButton = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 15px;
  border: none;
  background-color: #2a2a32;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const GroundToolButton = styled.div`
    width: 48px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
    background-color: #2a2a32;
    border-radius: 15px;
`;

const HelpButton = styled.button`
  position: fixed;
  right: 20px;
  bottom: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background-color: #000;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  z-index: 999999999999999;
`;



const BackgroundOverlay = styled.div`
    
    width: 100%;
    height: 100vh;
    object-fit: cover;
    position:absolute;
    opacity: 0.5; 
    z-index: 999;
    border-top-left-radius: 20px;
border-top-right-radius: 20px;
    background: linear-gradient(135deg, rgba(60, 60, 67, 0.1), rgba(60, 61, 69, 0.1));
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px); 
    background-repeat: no-repeat;
`;



const DocumentIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const EmojiIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 9H9.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 9H15.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const AudioIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 1C11.2044 1 10.4413 1.31607 9.87868 1.87868C9.31607 2.44129 9 3.20435 9 4V12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12V4C15 3.20435 14.6839 2.44129 14.1213 1.87868C13.5587 1.31607 12.7956 1 12 1Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19 10V12C19 13.8565 18.2625 15.637 16.9497 16.9497C15.637 18.2625 13.8565 19 12 19C10.1435 19 8.36301 18.2625 7.05025 16.9497C5.7375 15.637 5 13.8565 5 12V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Main Component
const QcastStudio: React.FC<QcastStudioProps> = ({
  qcastVideos,
  questionNumber = 1,
  totalQuestions = 5,
  userAvatar = 'https://i.imgur.com/6VBx3io.png',
  respondentAvatar = 'https://i.imgur.com/QIrZWGc.png',
  onCancel,
  onRecord,
  onPlayback,
  onnavigateVideo,
  setSnapshot
}) => {

  const [isRecording, setIsRecording] = useState(false);
  const [startPlayingQstn, setStartPlayingQstn] = useState<boolean>(false);

  const [videoUrl, setVideoUrl] = useState("");
  const [snapshotTaken, setSnapshotTaken] = useState(false);

  const [key, setKey] = useState(0);


  const [recordedVideos, setRecordedVideos] = useState<IndexedVideo>(null);

  const canvasRef = useRef<HTMLCanvasElement>(null);

  const navigate = useNavigate();

  const vidRef = useRef(null);
  const vidRecRef = useRef(null);
  const playerContainer = useRef(null);

  const isMobileScreen = useMediaQuery({ maxWidth: theme.breakpoints.maxTablet });


  const {
    countDown,
    countInterval,
    timer,
    start,
    stop,
    queueNextVideo,
    currentIndex,
    setCurrentIndex,
    startedRecord,
    setStartedRecord,
    setMaxDuration,
    allVideosRecorded,
    pauseRecording,
    resumeRecording,
    isPaused,
    setIsPaused,
    videoRef,
    blob,
    newVideo,
    nextVideo,
    duration,
    videos,
    captureSnapshot,
    mediaStream,
    isReady,
    forceInitialize,
    cleanupMediaStream

  } = useRecorder({ totalNumberOfVideoPermitted: totalQuestions });



  const getControlKeyColor = (type: string) => {
    if (type === 'prev' && currentIndex === 0) {
      return {
        color: '#828286',
        status: false
      }
    }

    if (type === 'prev' && currentIndex > 0) {
      return {
        color: '#FFFFFF',
        status: true
      }
    }

    if (type === 'next' && currentIndex + 1 < totalQuestions) {
      return {
        color: '#FFFFFF',
        status: true
      }
    }

    if (type === 'next' && currentIndex + 1 === totalQuestions) {
      return {
        color: '#828286',
        status: false
      }
    }

    return {
      color: '#FFFFFF',
      status: true
    }
  }

  const handleEdit = async () => {
    await cleanupMediaStream();
    if (isMobileScreen) {
      navigate('/qcast/review');
    } else {
      navigate('/qcast/edit');
    }

  }
const handleResume=()=>{
  if (isPaused) {

    resumeRecording();
    return;
  }
}
  const handleRecordClick = async () => {

    
    if (isRecording) {
      console.log("kkkkk4")
      await stop();
      setKey((prev) => prev + 1);
      setIsRecording(false);
      setStartPlayingQstn(false);
    } else {
      if (videos.length > 0) {
        console.log("kkkkk2")
        handleRetakeVideo();
        //setIsRecording(true);
        //setStartPlayingQstn(true)
      } else {
        console.log("kkkkk3")
        await forceInitialize()
        setIsRecording(true);
        setStartPlayingQstn(true)
      }
    }

    if (onRecord) onRecord();
  };

  const handleRetakeVideo = async () => {
    // await newVideo(currentIndex);
    await forceInitialize()
    // setMaxDuration(qcastVideos[currentIndex]?.maxDuration);
    setIsRecording(true);
    setStartPlayingQstn(true);




  }

  const handleStartRecording = async () => {

    setMaxDuration(qcastVideos[currentIndex]?.maxDuration);
    setStartPlayingQstn(false);
    await start(currentIndex);
    setStartedRecord(true);
  }

  const handleControlBtnClick = async (index: number) => {

    if (index === -1 && currentIndex === 0) return;
    if (index === 1 && currentIndex === qcastVideos.length - 1) return;
    const newIndex = currentIndex + index;
    onnavigateVideo(newIndex);
    setCurrentIndex(newIndex);
    setMaxDuration(qcastVideos[newIndex]?.maxDuration);
   if (isRecording && index > 0) {
      setStartPlayingQstn(false);
      await queueNextVideo();
    } else {
      const validVideos: IndexedVideo = videos.find((item: IndexedVideo) => item.index === newIndex);
    
        setRecordedVideos(validVideos || null);
        setIsRecording(false);
        setStartedRecord(false);
        setStartPlayingQstn(false);
    
      
    } 
          
            
        
          
        

  }

  const handlePauseVideo = async () => {
    await setIsPaused(true);
  }

  const handleCapture = async () => {
    if (isReady && !snapshotTaken) {
      const snapshot = await captureSnapshot(canvasRef);


      if (snapshot) {
        setSnapshot(snapshot);
        setSnapshotTaken(true)
      }
    }

  };

  useEffect(() => {
    if (allVideosRecorded > 0) {
      setIsRecording(false);
      setStartPlayingQstn(false)
    }
  }, [allVideosRecorded]);

  useEffect(() => {
    setTimeout(handleCapture, 2000);

  }, [canvasRef.current, videoRef.current, isReady]);

  useEffect(() => {
    if (blob) {
      setRecordedVideos({ index: currentIndex, video: blob })
    }
  }, [blob]);

  useEffect(() => {
    if (videos && videos.length > 0 && !blob) {
      setRecordedVideos(videos[currentIndex])
    }
  }, [videos])

  const handlePauseRecording = () => {
    pauseRecording()
  }

  useEffect(() => {
    if (recordedVideos?.video) {
      if (videoUrl && videoUrl.startsWith("blob:")) {
        URL.revokeObjectURL(videoUrl);
      }

      const url = URL.createObjectURL(recordedVideos.video);
      setVideoUrl(url);
    }

    return () => {
      if (videoUrl && videoUrl.startsWith("blob:")) {
        URL.revokeObjectURL(videoUrl);
      }
    };
  }, [recordedVideos]);


  return (
    <Container>
      <canvas ref={canvasRef} style={{ display: "none" }} />
      {/* <BackgroundOverlay /> */}
      <HeaderComp onCancel={() => { navigate('/') }} onAction={handleEdit} showEdit={!isRecording && !!blob} activateEdit={!!blob} type="respond" />
      <PageContent>

        {/* <div style={{paddingTop: "30px", width: "616px"}}>
        
          <SideMenu activeMenuItem="Record" disabledMenu={["Review","Edit"]} />
        </div> */}
        {
          !isMobileScreen && (<SideMenu activeMenuItem="Record" disabledMenu={["Review", "Edit"]} />)
        }

        <Content>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <QuestionIndicator>Question {currentIndex + 1} of {totalQuestions}</QuestionIndicator>
            {/* <QuestionIndicator>This is prompt for question {currentIndex + 1}, maximum 50 characters</QuestionIndicator> */}
          </div>



          <UserAvatar size={isMobileScreen ? "50px" : "100px"} active={!isRecording && !recordedVideos}>
            <VideoPlayer
              vidSrc={qcastVideos[currentIndex]?.url || ""}
              ref={vidRef}
              hidePlayVideoIcon={true}
              showProgress={true}
              size={100}
              playsize={48}
              play={!startedRecord && isRecording}
              autoPlay={false}
              hideSeek={true}
              onProgress={() => { }}
              onDuration={() => { }}
              onPause={() => { }}
              onPlay={() => { }}
              onReady={(status) => { }}
              onVideoEnded={handleStartRecording}
            />
          </UserAvatar>

          <RespondentContainer ref={playerContainer} size={"340px"}>
            {!isRecording && recordedVideos?.video ? (
              <div style={{ zIndex: 999999999999999, height: "100%", width: "100%" }}>
                <VideoPlayer
                  vidSrc={videoUrl}
                  ref={vidRecRef}
                  size={340}
                  play={false}
                  showProgress={true}
                  autoPlay={false}
                  showTimer={true}
                  hideSeek={true}
                  onProgress={() => { }}
                  onDuration={() => { }}
                  onPause={() => { }}
                  onPlay={() => { }}
                  onReady={(status) => { }}
                  onVideoEnded={() => { }}
                />

                <UserProfileAvatar size={playerContainer?.current?.offsetWidth || 120}><IoPerson color={"#000"} /></UserProfileAvatar>
              </div>

            ) : (
              <>
                <Recorder
                  key={key}
                  videoRef={videoRef}
                  size={340}
                  timer={timer}
                  countDown={countDown}
                  duration={qcastVideos[currentIndex]?.maxDuration}
                  message={`${currentIndex + 1} of ${totalQuestions}`}
                  startPlayingQstn={startPlayingQstn}
                  recordInitiated={isRecording}
                  startRecording={startedRecord}
                />
                <UserProfileAvatar size={playerContainer?.current?.offsetWidth || 120}><IoPerson color={"#000"} /></UserProfileAvatar>
              </>

            )}

          </RespondentContainer>
        </Content>

        <SideTools>
          {/* <GroundToolButton>
                <ToolButton>
                    <DocumentIcon />
                </ToolButton>
            </GroundToolButton>
          
            <GroundToolButton>
                <ToolButton>
                    <EmojiIcon />
                </ToolButton>
                <ToolButton>
                    <CgHeadset color={"#FFF"} size={25} />
                </ToolButton>
                <ToolButton>
                    <FiMoreHorizontal color={"#FFF"} size={25} />
                </ToolButton>
            </GroundToolButton> */}
        </SideTools>


      </PageContent>
      <Controls style={{marginLeft:"56px"}}>
        <SubControls style={{width:136}} >
        {!startedRecord && !isRecording && !recordedVideos && totalQuestions > 1 && (
          <ControlButton onClick={() => { handleControlBtnClick(-1) }} active={getControlKeyColor('prev').status || false}>
            <IoPlaySkipBackSharp color={getControlKeyColor('prev').color} size={20} />
          </ControlButton>
        )}

        {(
          <ControlButton  data-tooltip-id={`question-retake`} onClick={handleRetakeVideo} active={true} disabled={false}>
            <GrRotateRight color={'#FFFFFF'} size={20} />
          </ControlButton>
        )}

        {startedRecord && isRecording && (<>
          {
            isPaused ? (<ControlButton  data-tooltip-id={`question-resume`} onClick={handleResume} active={true} disabled={false}>
              <BsFillPlayFill color={'#FFFFFF'} size={20} />
            </ControlButton>) : (<ControlButton  data-tooltip-id={`question-pause`} onClick={handlePauseRecording} active={true} disabled={false}>
              <BsFillPauseFill color={'#FFFFFF'} size={20} />
            </ControlButton>)
          }</>

        )}

</SubControls>
<SubControls style={{justifySelf: "center"}}>

        <RecordButton onClickCapture={handleRecordClick}>
          {isRecording ? <FaSquare  data-tooltip-id={`question-stop`} color="red" size={32} /> : <FaCircle  data-tooltip-id={`question-record`} color="red" size={80} />}
        </RecordButton>
        </SubControls>
<SubControls style={{width:136}}>
        {currentIndex + 1 < totalQuestions && (
          <ControlButton  data-tooltip-id={`question-nextbtn`} onClick={() => { handleControlBtnClick(1) }} active={getControlKeyColor('next').status || true}>
            <IoPlaySkipForward color={getControlKeyColor('next').color} size={20} />
          </ControlButton>
        )}
        {!startedRecord && !isRecording && videos.length > 0 && currentIndex + 1 === totalQuestions && (
          <ControlButton onClick={handleEdit} active={!isRecording} disabled={isRecording}>
            <FiCheck color={getControlKeyColor('check').color} size={20} />
          </ControlButton>
        )}
</SubControls>
      </Controls>
      <HelpButton data-tooltip-id={`question-tooltip`}>?</HelpButton>
      <ReactTooltip
        id={`question-nextbtn`}
        style={{ width: "250px", zIndex: "99999999999999999", backgroundColor: "rgba(255, 255, 255,1)", color: "#222", borderRadius: 10 }}
        place="top"
        content={"Press the Next Question Button, after each of your responses, to proceed"}
      />
      <ReactTooltip
        id={`question-tooltip`}
        style={{ width: "250px", zIndex: "99999999999999999", backgroundColor: "rgba(255, 255, 255,1)", color: "#222", borderRadius: 10 }}
        place="top"
        content={"Click record to begin your interview. You will see a mute icon appear on screen, which means your mic is off whilst the question plays.After the mute icon disappears, please record your response."}
      />
       <ReactTooltip
        id={`question-retake`}
        style={{  zIndex: "9999999999999", backgroundColor: "rgba(255, 255, 255,1)", color: "#222", borderRadius: 10 }}
        place="top"
        content={"Retake Video"}
      />
       <ReactTooltip
        id={`question-pause`}
        style={{  zIndex: "9999999999999", backgroundColor: "rgba(255, 255, 255,1)", color: "#222", borderRadius: 10 }}
        place="top"
        content={"Pause Video"}
      />
       <ReactTooltip
        id={`question-resume`}
        style={{  zIndex: "9999999999999", backgroundColor: "rgba(255, 255, 255,1)", color: "#222", borderRadius: 10 }}
        place="top"
        content={"Resume Video"}
      />
      <ReactTooltip
        id={`question-record`}
        style={{  zIndex: "9999999999999", backgroundColor: "rgba(255, 255, 255,1)", color: "#222", borderRadius: 10 }}
        place="top"
        content={"Start Recording"}
      />
       <ReactTooltip
        id={`question-stop`}
        style={{  zIndex: "9999999999999", backgroundColor: "rgba(255, 255, 255,1)", color: "#222", borderRadius: 10 }}
        place="top"
        content={"Stop Recording"}
      />
    </Container>
  );
};

export default QcastStudio;